import React from 'react'
import { shape, string } from 'prop-types'

import ArticleHeader from '@/component/Primitive/ArticleHeader'

const ArticleLayoutHeader = ({ article, pageData }) => {
  const url = encodeURI(pageData?.url)
  article.__shareUrl = url
  return <ArticleHeader {...article} />
}

ArticleLayoutHeader.propTypes = {
  article: shape({
    headline: string
  }),
  pageData: shape({
    url: string
  })
}

export default ArticleLayoutHeader
